import { render } from "./message-video.vue?vue&type=template&id=22afdb32&scoped=true&ts=true"
import script from "./message-video.vue?vue&type=script&lang=ts"
export * from "./message-video.vue?vue&type=script&lang=ts"

import "./message-video.vue?vue&type=style&index=0&id=22afdb32&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22afdb32"]])

export default __exports__